@if (domainSettings) {
    <div class="menu-settings-div">
        <a class="apps-icon" [matMenuTriggerFor]="menu">
            <mat-icon>apps</mat-icon>
        </a>
        <mat-menu #menu="matMenu" class="avmup-menu">
            @for (app of cesarApplications; track app.display) {
                <a class="avmup-menu-item mat-mdc-menu-item" href="{{ getUrl(app.url) }}">
                    <img [matTooltip]="app.display" src="{{ app.icon }}" />
                    <span>{{ app.display }}</span>
                </a>
            }
        </mat-menu>
        <img class="domain-icon" src="{{ domainSettings.logo }}" />
    </div>
}
